import React, { useEffect } from 'react'
import { useMedia } from 'react-use'
import { Tag } from '@overdose/components'
import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'

import { useProject, useSession } from '~/hooks'
import BookmarkButton from '../BookmarkButton/BookmarkButton'
import DifficultyRating from '../DifficultyRating/DifficultyRating'
import { ProjectTitleProps } from './ProjectTitle.types'

const ProjectTitle = ({
  title,
  difficulty,
  category,
  className,
  isBookmarked: initialIsBookmarked,
  projectId,
}: ProjectTitleProps) => {
  const isTabletScreen = useMedia('(min-width: 768px)', false)
  const { session } = useSession()
  const { isBookmarked, handleOnBookMarkProject } = useProject({
    projectTitle: title,
    projectId,
    isBookmarked: initialIsBookmarked,
  })

  return (
    <div
      className={classNames(
        className,
        'w-full flex items-center justify-between'
      )}>
      <div
        className={classNames('flex flex-col justify-center gap-6 sm:gap-4')}>
        <Typography tag={TypographyTag.h1} variant={TypographyVariant.Heading4}>
          {title}
        </Typography>
        <div className={classNames('flex', 'gap-4', 'flex-wrap')}>
          <Typography
            className={classNames('flex', 'gap-2', 'items-center')}
            tag={TypographyTag.div}
            variant={TypographyVariant.BodyLargeBold}>
            Difficulty <DifficultyRating difficulty={difficulty} />
          </Typography>
          <div
            className={classNames('flex', 'gap-2', 'flex-wrap')}
            style={
              {
                '--tag-default-color-bg':
                  'var(--color-text-primary-blue, #0C254C)',
                '--tag-default-color-text': 'white',
              } as React.CSSProperties
            }>
            <Tag size='sm' variant='default'>
              <Typography
                className={classNames('uppercase')}
                tag={TypographyTag.span}
                variant={TypographyVariant.BodySmall}>
                {category.name}
              </Typography>
            </Tag>
          </div>
        </div>
      </div>
      {session?.token?.isLoggedIn && (
        <div className={classNames('self-end', 'md:self-center')}>
          <BookmarkButton
            onClickToggle={handleOnBookMarkProject}
            active={isBookmarked}
            size={isTabletScreen ? 'lg' : 'sm'}
          />
        </div>
      )}
    </div>
  )
}

export default ProjectTitle
